<template>
  <div class="login-container">
    <div class="login-box">
      <!--头像标志区域-->
      <div class="avatar-box">
        <img src="../assets/logo.png" alt="">
      </div>
      <!--登录表单区域-->
      <el-form
          ref="loginFormRef"
          :rules="loginFormRules"
          :model="loginForm"
          label-width="0px"
          class="login-form">
        <!--用户名-->
        <el-form-item prop="username">
          <el-input
              v-model="loginForm.username"
              prefix-icon="iconfont icon-user">
          </el-input>
        </el-form-item>
        <!--密码-->
        <el-form-item prop="password">
          <el-input
              type="password"
              v-model="loginForm.password"
              prefix-icon="iconfont icon-3702mima">
          </el-input>
        </el-form-item>
        <!--登录按钮-->
        <el-form-item class="btn">
          <!-- <el-button type="primary" @click="login">登录</el-button> -->
          <el-button 
            type="primary" 
            @click="login" 
            :disabled="loginSecurity.isLocked && Date.now() < loginSecurity.lockUntil"
          >
            {{ loginSecurity.isLocked && Date.now() < loginSecurity.lockUntil ? '登录已锁定' : '登录' }}
          </el-button>
          <el-button type="info" @click="resetLoginForm">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="file-box">
      <!-- <el-link :underline="false" href="https://beian.miit.gov.cn/#/Integrated/index">渝 ICP 备 2022007989 号 - 1</el-link> -->
    </div>
  </div>
</template>

<script>
import REQUEST from '@/utils/request';
export default {
  name: "login",
  data() {
    return {
      // 登录表单数据
      loginForm: {
        username: '',
        password: ''
      },
      // 登录安全状态
      loginSecurity: {
        attemptCount: 0,       // 当前尝试次数
        maxAttempts: 10,         // 最大尝试次数
        isLocked: false,        // 是否被锁定
        lockUntil: 0,           // 锁定截止时间（时间戳）
        lockDuration: 10 * 60 * 1000 // 锁定时长：5分钟（毫秒）
      },
      // 登录表单验证规则对象
      loginFormRules: {
        username: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 3, max: 9, message: '长度在 3 到 9 个字符', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 6, max: 15, message: '长度在 6 到 15 个字符', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    // 点击重置按钮重置登录表单
    resetLoginForm() {
      this.$refs.loginFormRef.resetFields()
    },
    // 点击登录按钮
// 点击登录按钮
  login() {
    this.$refs.loginFormRef.validate(async valid => {
      if (!valid) return;

      const { loginSecurity } = this;

      // 1. 检查是否被锁定
      if (loginSecurity.isLocked) {
        const now = Date.now();
        if (now < loginSecurity.lockUntil) {
          const remaining = Math.ceil((loginSecurity.lockUntil - now) / 1000 / 60);
          return this.$message.error(`登录失败次数过多，请 ${remaining} 分钟后再试`);
        } else {
          // 锁定时间已过，重置状态
          this.resetLoginSecurity();
        }
      }

      try {
        const { data: res } = await REQUEST.post('/api/public/login', this.loginForm);
        console.log(res)
        if (res.status !== 0) {
          // 2. 登录失败，增加尝试次数
          loginSecurity.attemptCount += 1;

          if (loginSecurity.attemptCount >= loginSecurity.maxAttempts) {
            // 达到最大次数，锁定
            loginSecurity.isLocked = true;
            loginSecurity.lockUntil = Date.now() + loginSecurity.lockDuration;
            this.$message.error(`登录失败次数过多，账号已锁定5分钟`);
          } else {
            this.$message.error(`登录失败，还可尝试 ${loginSecurity.maxAttempts - loginSecurity.attemptCount} 次`);
          }
          return;
        }

        // 3. 登录成功，重置安全状态
        this.resetLoginSecurity();
        window.sessionStorage.setItem('token', res.token);
        await this.$router.push('/home');

      } catch (err) {
        console.error('登录请求异常', err);
        this.$message.error('网络异常，请稍后再试');
      }
    });
  },

  // 重置登录安全状态
  resetLoginSecurity() {
    this.loginSecurity = {
      attemptCount: 0,
      maxAttempts: 5,
      isLocked: false,
      lockUntil: 0,
      lockDuration: 5 * 60 * 1000
    };
  }
  }
}
</script>

<style lang="less" scoped>
.login-container {
  background-color: #f5f6fa;
  height: 100%;
}

.login-box {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 450px;
  height: 300px;
  background-color: #fff;
  border-radius: 5px;
  box-shadow: 0 1px 5px rgba(55, 122, 255, 0.3);

  .avatar-box {
    width: 130px;
    height: 130px;
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%);
    border-radius: 50%;
    padding: 10px;
    border: 1px solid #eee;
    background-color: #fff;
    //box-shadow: 0 0 10px #ddd;
    box-shadow: 0 0 10px rgba(55, 122, 255, 0.3);

    img {
      width: 100%;
      height: 100%;
      border-radius: 50%;
      background-color: #996;
    }
  }

  .login-form {
    position: absolute;
    bottom: 0;
    width: 100%;
    box-sizing: border-box;
    padding: 20px;

    .btn {
      display: flex;
      justify-content: flex-end;
    }
  }
}

.file-box {
  position: absolute;
  left: 10px;
  bottom: 10px;
  foot-size: 12px;
  color: #999;
}


</style>
